import React,{useState,useEffect} from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  BankAccountDatatable = (props) => {

    const [t] = useTranslation();     
    const [entityId, setEntityId] = useState();
    const tableName = t('bankAccount.label.bankAccounts'); 
    const departmentInVisible = props.entityName==='company' ? false : true;    

    const columns = [       
             { name: "Id", data: "id", selector: "id", omit: true},
             { name: t('bankAccount.label.iban'), data: "iban", sortable: true, selector: "iban"},    		
             { name: t('bankAccount.label.currency'), data: "currency", sortable: true, selector: "currency"},    		
             { name: t('bankAccount.label.bankName'), data: "bank.name",  sortable: true,  selector: "bank.name"},
             { name: t('bankAccount.label.department'), data: "department.name", sortable: true,  selector: "department.name", omit: departmentInVisible}                  
     ];        
 
 
         
     const columnsData = [       
         { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
         { name: t('bankAccount.label.iban'), data: "iban",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
         { name: t('bankAccount.label.currency'), data: "currency", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('bankAccount.label.bankName'), data: "bank.name", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('bankAccount.label.department'), data: "department.name", orderable: true,  searchable: true, search: {value: '',regex: false}}                 
     ];        
     const url = RestService.getBaseURL()+"bankAccount/getBankAccountDataTableList?entityId="+entityId;   
     const urlExcel = RestService.getBaseURL()+"";          
    
   
 
     useEffect(() => {      
        setEntityId(props.entityId);
      }, [props.entityId])

     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={false}
             />
           
         );
    
 
  
 };

export default BankAccountDatatable;

